class CommandModel {
    index = null;
    id = null;

    type = null;

    data = null;
}
export default CommandModel;